export const NAME = 'media';